module.exports = __webpack_public_path__ + "static/media/logo-dark.df6288e3.png";